import ListItemCategory from './ListItemCategory.jsx';

export {
  ListItemCategory
}


// WEBPACK FOOTER //
// ./components/category-detail/list-category-item/index.js